import { useRef, useState, useEffect, FunctionComponent, ReactNode, ReactElement } from 'react';
import { Tooltip } from '@mui/material';
import { Box, styled } from '@mui/system';

const TooltipContentContainer = styled(Box)(() => ({
	display: 'block',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
}));

const OverflowCell: FunctionComponent<{
	children: ReactNode;
	maxWidth?: number;
}> = ({ children, maxWidth }): ReactElement => {
	const [isOverflowed, setIsOverflow] = useState(false);
	const textElementRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!textElementRef.current) return;
		setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
	}, [children]);

	return (
		<Tooltip arrow title={children} disableHoverListener={!isOverflowed}>
			<TooltipContentContainer ref={textElementRef} sx={{ maxWidth }}>
				{children}
			</TooltipContentContainer>
		</Tooltip>
	);
};

export default OverflowCell;
